import React, { Component } from "react";
import { Grid, Modal, Segment, Button, List, Radio } from "semantic-ui-react";
import _ from "lodash";
import SearchHeaderTitle from "../pages/SearchHeaderTitle";

class NewSearch extends Component {
  state = {
    selectedOption: {
      value: "",
      category: "",
      groupType: "",
    },
    menuItem: {},
  };
  componentDidMount() {}

  handleChange = (e, value, menuId, category, groupType, menuItem) => {
    const selectedOption = { value, category, menuId, groupType };
    this.setState({ selectedOption, menuItem });
  };

  render() {
    const columns = [];
    let columnSize = 5;
    if (Object.keys(this.props.data).length !== undefined) {
      columnSize = Object.keys(this.props.data).length;
    }
    if (this.props.data !== undefined) {
      if (columnSize < 3) {
        columns.push(<Grid.Column width={6} key={`left`} />);
      }
      _.map(Object.keys(this.props.data), (popupTitle) => {
        const list = [];
        const popupMenuItem = this.props.data[popupTitle];
        _.map(popupMenuItem.listItems, (item, index) => {
          list.push(
            <List.Item key={`list_item_${popupTitle}_${index}`}>
              <Radio
                name="group"
                checked={
                  this.state.selectedOption.category === item.MenuGroup &&
                  this.state.selectedOption.groupType === item.MenuHeader &&
                  this.state.selectedOption.value === item.MenuTitle &&
                  this.state.selectedOption.menuId === item.MenuId
                }
                value={item.MenuTitle}
                label={item.MenuTitle}
                onChange={() =>
                  this.handleChange(
                    this,
                    item.MenuTitle,
                    item.MenuId,
                    item.MenuGroup,
                    item.MenuHeader,
                    item
                  )
                }
              />
            </List.Item>
          );
        });
        columns.push(
          <Grid.Column
            key={`popup_column_${popupTitle}`}
            width={columnSize < 5 ? 4 : parseInt(16 / columnSize, 10)}
          >
            <Segment className={"padding-5"}>
              <div>
                <SearchHeaderTitle
                  titleImage={popupMenuItem.titleImage}
                  titleName={popupMenuItem.titleName}
                />
                <List className={"padding-top-10-percent"}>{list}</List>
              </div>
            </Segment>
          </Grid.Column>
        );
      });
      if (columnSize < 3) {
        columns.push(<Grid.Column width={6} key={`right`} />);
      }
    }
    return (
      <Modal
        trigger={this.props.source}
        closeIcon
        open={this.props.active}
        onClose={() => this.props.dialogClose(this)}
        className={"dialog-render"}
      >
        <Modal.Header className={"report-name-header"}>
          Populate new search for:
        </Modal.Header>
        <Modal.Content image scrolling>
          <Modal.Description>
            <p className={"new-search-title"}>{this.props.searchText}</p>
            <Grid
              columns={columnSize === 0 ? 1 : columnSize}
              centered
              stackable
            >
              <Grid.Row> {columns} </Grid.Row>
            </Grid>
            <br />
            <hr className={"border-transparent"} />
            <br />
          </Modal.Description>
          <br />
        </Modal.Content>
        <Modal.Actions className={"dialog-actions"}>
          <div className={"float-right"}>
            <Button
              className={"no-background-color"}
              onClick={() =>
                this.props.previewNewSearch(
                  this,
                  this.state.selectedOption,
                  this.props.searchData,
                  this.state.menuItem
                )
              }
            >
              Preview
            </Button>
            <Button
              className={"no-background-color"}
              onClick={() => this.props.dialogClose(this)}
            >
              Cancel
            </Button>
          </div>
        </Modal.Actions>
      </Modal>
    );
  }
}

export default NewSearch;



// WEBPACK FOOTER //
// ./src/components/dialogs/NewSearch.js